var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_390_416)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9582 7.93835C21.1686 7.86203 21.4085 7.88167 21.6086 8.00535C21.7645 8.10168 21.8747 8.2478 21.928 8.41276C21.9368 8.44001 21.944 8.46761 21.9496 8.49542C21.9683 8.58834 21.9696 8.68535 21.9515 8.78143C21.9445 8.81934 21.9345 8.85676 21.9216 8.89331L17.1403 23.2371C17.0458 23.5207 16.7918 23.7211 16.494 23.7471C16.1962 23.7731 15.9114 23.6197 15.7691 23.3568L12.5156 17.3426L6.50089 14.0887C6.23795 13.9465 6.0846 13.6617 6.11059 13.3639C6.13659 13.066 6.33697 12.8121 6.62058 12.7176L20.9582 7.93835ZM18.4371 10.3599L8.73726 13.5932L12.9337 15.8633L18.4371 10.3599ZM13.9945 16.924L16.2647 21.1204L19.498 11.4205L13.9945 16.924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -13.7029,
    y: -16.7028,
    width: 60.2635,
    height: 101.527,
    rx: 4.5,
    stroke: "#9747FF",
    strokeDasharray: "10 5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_390_416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.b669119e47da4545a44b88ab9da7d8ec.svg";
export { ForwardRef as ReactComponent };